import { useRef } from "react";
import { useNamedRoutes } from "../../../NamedRoutes";
import { RowProps } from "../../types";

import { Link } from "react-router-dom";
import listStyle from "../../List.module.scss";
import { ResponsiveContainer } from "./ResponsiveContainer";



export const Col: React.FC<RowProps> = ({
    responsive,
    choice,
    breakpoint,
    value,
    link,
    nextLine = false,
    className,
    up,
}) =>
{
    const { generate } = useNamedRoutes();

    const linkRef = useRef<HTMLAnchorElement>(null);

    const Container = ResponsiveContainer(responsive, breakpoint, up);

    const route = link ? generate(link, { id: value }) : "";

    const Value: React.FC = () => <>
        {choice}
        <span
            data-testid="list-colum"
            className={`${listStyle.text} ${choice ? listStyle.rowTextCenterWithMarginAround : listStyle.rowTextCenter}`}
        >
            {value}
        </span>
    </>;


    return <Container>


        <div
            className={` ${className} ${listStyle.col} ${nextLine ? listStyle.flexNextLine : ''}`}>
            {link ? <Link
                style={{ color: "blue" }}
                ref={linkRef}
                className={listStyle.link}
                to={route}
            >
                <Value />
            </Link> : <Value />}
        </div>

    </Container>;
};